import { render, staticRenderFns } from "./MultiStepQuizV4Dialog.vue?vue&type=template&id=398dca67&scoped=true&"
import script from "./MultiStepQuizV4Dialog.vue?vue&type=script&lang=js&"
export * from "./MultiStepQuizV4Dialog.vue?vue&type=script&lang=js&"
import style0 from "./MultiStepQuizV4Dialog.vue?vue&type=style&index=0&id=398dca67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398dca67",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
